import { merge, mergeWith } from 'lodash-es';
import { PartialDeep } from 'type-fest';

import { defaultHosts as devDefaultHosts, env as devEnv } from './env/dev';
import { DeployEnv, Env, Hosts } from './env/env.type';
import { defaultHosts as prodDefaultHosts, env as prodEnv } from './env/prod';
import {
  defaultHosts as stageDefaultHosts,
  env as stageEnv,
} from './env/stage';
import { defaultHosts as uatDefaultHosts, env as uatEnv } from './env/uat';

function customHostsMerger(objValue: string, srcValue: unknown) {
  if (srcValue === null || srcValue === undefined || srcValue === '') {
    return objValue; // Keep the original value (from defaultHosts)
  }
  // Let lodash handle other merges
  return undefined;
}

export type OptsGetEnvConfig = {
  /**
   * overwrite config in localhost mode
   * @default {}
   */
  localOverwrite?: PartialDeep<Env>;
  /**
   * deploy env
   * @default 'dev'
   */
  deployEnv?: DeployEnv;
  hosts?: Partial<Hosts>;
};

/**
 * Generate app config by deploy env
 *
 * @export
 * @param {OptsGetEnvConfig} opts
 * @returns {Env}
 */
export function getEnvConfig(opts: OptsGetEnvConfig): Env {
  const { deployEnv = 'dev', localOverwrite = {}, hosts } = opts;
  const env = (() => {
    switch (deployEnv) {
      case 'dev':
        return devEnv({
          hosts: mergeWith({}, devDefaultHosts, hosts, customHostsMerger),
        });
      case 'uat':
        return uatEnv({
          hosts: mergeWith({}, uatDefaultHosts, hosts, customHostsMerger),
        });
      case 'stage':
        return stageEnv({
          hosts: mergeWith({}, stageDefaultHosts, hosts, customHostsMerger),
        });
      case 'prod':
      default:
        return prodEnv({
          hosts: mergeWith({}, prodDefaultHosts, hosts, customHostsMerger),
        });
    }
  })();
  return merge({}, env, { deployEnv } as PartialDeep<Env>, localOverwrite);
}
